// src/calls/storeGlue.js
import { callConstants as T } from '../actions/constants';

export function callActionsInternal(service, dispatch, getState) {
    if (window.__CALL_GLUE_BOUND__) return; // защита от повторных подписок
    window.__CALL_GLUE_BOUND__ = true;

    const set = (patch) => {
        console.log('[CALLDBG][GLUE] PATCH -> dispatch', patch);
        dispatch({ type: T.PATCH_STATE, payload: patch });
        // снапшот для отладки
        try {
            const l = service.getLocalStream?.();
            const a = l?.getAudioTracks?.() || [];
            const v = l?.getVideoTracks?.() || [];
            console.log('[CALLDBG][GLUE] snapshot', {
                status: (getState()?.call?.status),
                uiMic: (getState()?.call?.mic),
                uiCam: (getState()?.call?.cam),
                audioEnabled: a.map(t => t.enabled),
                videoEnabled: v.map(t => t.enabled),
            });
        } catch { }
    };

    service.on('incoming', ({ callId, from, video, chatId }) => {
        console.log('[CALLDBG][GLUE] event incoming', { callId, from, video, chatId });
        set({
            status: 'ringing',
            incoming: true,
            callId,
            peerId: from,
            mode: video ? 'video' : 'audio',
            chatId,
        });
    });

    // NB: 'connecting' — только до 'in-call'. во время ICE-restart в звонке используем 'reconnecting'
    service.on('connecting', () => {
        console.log('[CALLDBG][GLUE] event connecting');
        const s = getState()?.call?.status;
        if (s !== 'in-call') set({ status: 'connecting' });
    });

    service.on('reconnecting', () => {
        console.log('[CALLDBG][GLUE] event reconnecting');
        set({ reconnecting: true }); // флаг для UI (если надо что-то показывать)
    });

    service.on('connected', (payload) => {
        console.log('[CALLDBG][GLUE] event connected', payload);
        const startedAt = (payload && payload.startedAt) || Date.now();
        const audioEn = !!service.getLocalStream()?.getAudioTracks?.()[0]?.enabled;
        const videoEn = !!service.getLocalStream()?.getVideoTracks?.()[0]?.enabled;
        set({ status: 'in-call', startedAt, mic: audioEn, cam: videoEn, reconnecting: false });
    });

    service.on('ended', ({ reason }) => {
        console.log('[CALLDBG][GLUE] event ended', { reason });
        set({
            status: 'idle',
            incoming: false,
            callId: null,
            peerId: null,
            mode: null,
            startedAt: null,
            lastReason: reason,
            reconnecting: false,
            mic: true,
            cam: true,
        });
    });

    // живое обновление микрофона из CallService
    service.on('local-mic', ({ enabled }) => {
        console.log('[CALLDBG][GLUE] event local-mic', { enabled });
        set({ mic: !!enabled });
    });

    // опционально — и для камеры:
    service.on('local-cam', ({ enabled }) => {
        console.log('[CALLDBG][GLUE] event local-cam', { enabled });
        set({ cam: !!enabled });
    });

    // просто лог рингера
    service.on('ring:start', () => console.log('[CALLDBG][GLUE] ring:start'));
    service.on('ring:stop', () => console.log('[CALLDBG][GLUE] ring:stop'));
}
